module.exports = __webpack_public_path__ + "static/media/logo_premiaciones.6b8aeccb.png";